import React from 'react';
import MaskedTimeInput, { IMaskedTimeInputProps } from '../MaskedTimeInput';

export type ITimeFieldProps = Omit<IMaskedTimeInputProps, 'data-testid'> & {
    testid?: string;
};

const TimeField: React.FC<ITimeFieldProps> = ({ testid, ...rest }) => (
    <MaskedTimeInput {...rest} data-testid={testid ? `time-field-${testid}` : undefined} />
);

export default TimeField;
